import {
  Widget
} from 'components/common'
import styled from 'styled-components'


export const WidgetComponentStyled = styled(Widget)`
  max-width: 1100px;
  padding: 60px;
`